(() => {
  "use strict";

  class DigiClubComparison {
    constructor(section) {
      this.section = section;

      this.enabled =
        section.dataset.animationEnabled === "true";

      this.revealItems = [
        ...section.querySelectorAll(
          "[data-digi-club-comparison-reveal]"
        )
      ];

      this.rows = [
        ...section.querySelectorAll(
          "[data-digi-club-comparison-row]"
        )
      ];

      this.reduceMotionQuery =
        window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        );

      this.observer = null;

      this.handleReducedMotion =
        this.handleReducedMotion.bind(this);

      this.init();
    }

    init() {
      if (
        !this.enabled ||
        this.reduceMotionQuery.matches
      ) {
        this.showAll();
        return;
      }

      this.createObserver();
      this.bindEvents();
    }

    bindEvents() {
      if (
        typeof this.reduceMotionQuery.addEventListener ===
        "function"
      ) {
        this.reduceMotionQuery.addEventListener(
          "change",
          this.handleReducedMotion
        );
      } else if (
        typeof this.reduceMotionQuery.addListener ===
        "function"
      ) {
        this.reduceMotionQuery.addListener(
          this.handleReducedMotion
        );
      }
    }

    createObserver() {
      const items = [
        ...this.revealItems,
        ...this.rows
      ];

      if (!items.length) return;

      this.observer =
        new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                return;
              }

              entry.target.classList.add(
                "is-visible"
              );

              this.observer.unobserve(
                entry.target
              );
            });
          },
          {
            threshold: 0.12,
            rootMargin:
              "0px 0px -8% 0px"
          }
        );

      items.forEach(item => {
        this.observer.observe(item);
      });
    }

    handleReducedMotion(event) {
      if (!event.matches) {
        return;
      }

      this.destroyObserver();
      this.showAll();
    }

    showAll() {
      const items = [
        ...this.revealItems,
        ...this.rows
      ];

      items.forEach(item => {
        item.classList.add(
          "is-visible"
        );
      });
    }

    destroyObserver() {
      if (!this.observer) return;

      this.observer.disconnect();
      this.observer = null;
    }

    destroy() {
      this.destroyObserver();

      if (
        typeof this.reduceMotionQuery.removeEventListener ===
        "function"
      ) {
        this.reduceMotionQuery.removeEventListener(
          "change",
          this.handleReducedMotion
        );
      } else if (
        typeof this.reduceMotionQuery.removeListener ===
        "function"
      ) {
        this.reduceMotionQuery.removeListener(
          this.handleReducedMotion
        );
      }
    }
  }

  const initializeSections = root => {
    root
      .querySelectorAll(
        "[data-digi-club-comparison]"
      )
      .forEach(section => {
        if (
          section.dataset.digiClubComparisonInitialized ===
          "true"
        ) {
          return;
        }

        section.dataset.digiClubComparisonInitialized =
          "true";

        section.__digiClubComparison =
          new DigiClubComparison(section);
      });
  };

  const unloadSection = section => {
    if (!section) return;

    const comparison =
      section.matches?.(
        "[data-digi-club-comparison]"
      )
        ? section
        : section.querySelector?.(
            "[data-digi-club-comparison]"
          );

    if (!comparison) return;

    comparison.__digiClubComparison?.destroy();

    delete comparison.__digiClubComparison;

    delete comparison.dataset
      .digiClubComparisonInitialized;
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        initializeSections(document);
      }
    );
  } else {
    initializeSections(document);
  }

  document.addEventListener(
    "shopify:section:load",
    event => {
      initializeSections(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    event => {
      unloadSection(event.target);
    }
  );

  document.addEventListener(
    "shopify:block:select",
    event => {
      const block =
        event.target.closest?.(
          "[data-digi-club-comparison-row]"
        );

      if (!block) return;

      block.classList.add(
        "is-visible"
      );
    }
  );
})();